export const FETCH_USERS = 'FETCH_USERS';
export const FETCH_USER = 'FETCH_USER';
export const FETCH_WAITLIST = "FETCH_WAITLIST";
export const BULK_PROMOTE = "BULK_PROMOTE";
export const UPDATE_USER = "UPDATE_USER";
export const FETCH_USER_STATS = "FETCH_USER_STATS";
export const UPDATE_ID_VERIFICATION = "UPDATE_ID_VERIFICATION";